import { PsqWidgetIcn, PsqWidgetLogo } from 'components/Icons'
import React from 'react'
import styles from './psqWidget.module.scss'
import { Trans, useTranslation } from 'react-i18next'
import { PSQ_HREF } from 'constants/global'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'
import { MIN_AGE_FOR_PSQ } from 'constants/profile'

const PsqWidget = () => {
  const { t } = useTranslation('strPsq')
  const ownAge = useSelector((state: AppState) => state.profile?.loadedProfile?.age)
  return (
    <div className={styles.psqWidget}>
      <div className={styles.ringWrapper}>
        <PsqWidgetIcn />
        <span className={styles.text}>
          <PsqWidgetLogo />
          {t('widgetMsg')}
        </span>
      </div>

      {ownAge && ownAge >= MIN_AGE_FOR_PSQ ? (
        <div className={styles.bottomText}>
          <Trans ns='strPsq' i18nKey={'widgetLinkText'}>
            Until you start playing fill in our{' '}
            <a href={PSQ_HREF} className={styles.link}>
              ‘Rate My Game’
            </a>{' '}
            questionnaire
          </Trans>
        </div>
      ) : null}
    </div>
  )
}

export default PsqWidget
